import styled from 'styled-components';

export const UrlView = styled.iframe`
  width: 100%;
  height: 98%;
  width: 96%;
  height: 88%;
  margin: 0px 35px;
`;
